var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKooHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29465",
    "data-name": "Group 29465",
    transform: "translate(-555.999 -662.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(555.999 662.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-koo",
    transform: "translate(566.916 666.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50726",
    "data-name": "Path 50726",
    d: "M25.016,3.419c-.028-.323-.194-1.539-1.089-1.707-.215-.04-.607.2.279.839-.1-.072-.872-.628-1.039-.06-.041.139-.133.4.74.641,0,0-.743-.24-.778.2a4.577,4.577,0,0,1,1.887.089Z",
    transform: "translate(-7.851 0)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50727",
    "data-name": "Path 50727",
    d: "M21.133,12.5c-.114-.378-.38-1.933-.38-1.933A5.057,5.057,0,0,0,16.032,6c-2.651,0-4.8,2.488-4.8,5.558,0,.209.013.414.033.617a.228.228,0,0,1,.086.025,3.634,3.634,0,0,1,1.7,3.754c-.23.7-.906,1.447-2.735,1.447A9.058,9.058,0,0,1,9,17.292c-1.033.109-.8.835-.8.835.77,2.31,3.588,3.151,4.889,3.422l.674,2.022h-.62a.237.237,0,0,0,0,.475h.851l.88.88a.237.237,0,0,0,.336-.336l-.545-.545h.851a.237.237,0,0,0,0-.475H14.264l-.642-1.926.137.019a8.27,8.27,0,0,0,2.857.014l.473,1.418h-.62a.237.237,0,1,0,0,.475h.851l.88.88a.237.237,0,0,0,.336-.336l-.545-.545h.851a.237.237,0,1,0,0-.475H17.589l-.506-1.519A6.04,6.04,0,0,0,20.7,18.931,8.394,8.394,0,0,0,21.133,12.5Z",
    transform: "translate(0 -2.254)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50728",
    "data-name": "Path 50728",
    d: "M13.634,23.214a3.16,3.16,0,0,0-1.329-3.1,13.934,13.934,0,0,0-2.155,4.124C12.087,24.511,13.326,24.157,13.634,23.214Z",
    transform: "translate(-1.036 -9.663)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50729",
    "data-name": "Path 50729",
    d: "M36.71,21.48a11.5,11.5,0,0,1-.067,4.215C38.553,25.311,38.261,23.384,36.71,21.48Z",
    transform: "translate(-14.947 -10.382)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_516",
    "data-name": "Ellipse 516",
    cx: 0.475,
    cy: 0.475,
    r: 0.475,
    transform: "translate(15.217 8.02)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_517",
    "data-name": "Ellipse 517",
    cx: 0.475,
    cy: 0.475,
    r: 0.475,
    transform: "translate(18.541 8.02)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50730",
    "data-name": "Path 50730",
    d: "M25.808,17.9l.727-.359a.119.119,0,0,1,.107,0l.7.36a.119.119,0,0,1,0,.21l-.687.368a.118.118,0,0,1-.109,0l-.739-.369A.119.119,0,0,1,25.808,17.9Z",
    transform: "translate(-9.223 -8.306)",
    fill: "#c62828"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKooHighlighted);
export default __webpack_public_path__ + "static/media/kooHighlighted.d2acd373a2d6202dd4de425f54a5bc59.svg";
export { ForwardRef as ReactComponent };